import {NftRewardPrize, NftOwnership} from "@devour/client";
import {ButtonHTMLAttributes, ReactElement} from "react";
import FrameButton from "@/components/buttons/FrameButton";
import {RewardNftRedemptionState} from "@/components/goVip/GoVipRewardsSelectedNft";
import {useActiveWalletConnectionStatus} from "thirdweb/react";
import {toggleReauthenticateModal} from "@/redux/meta/metaActions";
import {useDispatch} from "react-redux";
import RedeemLootboxButton from "@/components/RedeemLootboxButton";
import type {Chain} from "thirdweb/chains";

interface Props {
    redemptionState: RewardNftRedemptionState;
    toggleDrawer: () => void;
    prize?: NftRewardPrize;
    onNextLootbox?: () => void;
    ownership: NftOwnership;
    onVirtualRedemption: () => void;
    contractAddress: string;
    onTransactionStarted?: () => void;
    onTransactionSubmit: (transactionHash: `0x${string}`) => void;
    onTransactionConfirmed: (transactionHash: `0x${string}`) => void;
    relayerUrl?: string;
    forwarderAddress?: string;
    chain?: Chain;
}

export default function GoVipRewardsSelectedNftFooter(props: Props): ReactElement {
    const dispatch = useDispatch();
    const thirdwebStatus = useActiveWalletConnectionStatus();

    function onRedeemNow() {
        if (props.ownership.isVirtual) {
            props.onVirtualRedemption();
            return;
        }
        if (thirdwebStatus !== "connected") {
            dispatch(toggleReauthenticateModal(true));
        }
    }

    function renderDefaultFooter(): ReactElement {
        if (thirdwebStatus !== "connected" || props.ownership.isVirtual) {
            return (
                <div className="govip-rewards-drawer_footer_default">
                    <FrameButton
                        color="white-drop-shadow-devour"
                        size="normal"
                        className="govip-rewards-drawer_footer_default_button"
                        onClick={onRedeemNow}
                    >
                        Redeem Now
                    </FrameButton>
                </div>
            );
        }

        return (
            <div className="govip-rewards-drawer_footer_default">
                <RedeemLootboxButton
                    nftId={props.ownership.nftId}
                    contractAddress={props.contractAddress}
                    onTransactionStarted={props.onTransactionStarted}
                    onTransactionSubmit={props.onTransactionSubmit}
                    onTransactionConfirmed={props.onTransactionConfirmed}
                    relayerUrl={props.relayerUrl}
                    forwarderAddress={props.forwarderAddress}
                    chain={props.chain}
                />
            </div>
        );
    }

    function renderRedemptionOpeningFooter(): ReactElement {
        return (
            <div className="govip-rewards-drawer_footer_in-progress">
                Reward attempt was disconnected.
                Please select another box, or wait a minute and try again.
            </div>
        );
    }

    function renderRedemptionInProgressFooter(): ReactElement {
        return (
            <div className="govip-rewards-drawer_footer_in-progress">
                Unlocking
                <div className="loading-dot" />
                <div className="loading-dot" />
                <div className="loading-dot" />
            </div>
        );
    }

    function renderPrizeRevealFooter(): ReactElement {
        return (
            <div className="govip-rewards-drawer_footer_default">
                {props.onNextLootbox &&
                    <FrameButton
                        <ButtonHTMLAttributes<HTMLButtonElement>>
                        color="purple"
                        size="normal"
                        className="govip-rewards-drawer_footer_default_button"
                        onClick={props.onNextLootbox}
                    >
                        Redeem Next
                    </FrameButton>
                }
                <FrameButton
                    <ButtonHTMLAttributes<HTMLButtonElement>>
                    color="purple-outline"
                    size="normal"
                    className="govip-rewards-drawer_footer_default_button"
                    onClick={props.toggleDrawer}
                >
                    Confirm and close
                </FrameButton>
            </div>
        );
    }

    return (
        <>
            {props.redemptionState === RewardNftRedemptionState.NOT_INITIATED && renderDefaultFooter()}
            {props.redemptionState === RewardNftRedemptionState.OPENING && renderRedemptionOpeningFooter()}
            {props.redemptionState === RewardNftRedemptionState.IN_PROGRESS && renderRedemptionInProgressFooter()}
            {props.redemptionState === RewardNftRedemptionState.DONE && renderPrizeRevealFooter()}
        </>
    );

}